<div [ngClass]="showFormGrouped ? 'idp-form-grouped' : ''">
  <div class="idp-radio__wrapper">
    <idp-error-tooltip
      *ngIf="(errorState || error) && submitAttempt && showErrorToolTip"
      [arrowPosition]="'left'"
      [errorMessage]="errorMessage"
      [icon]="icon"
      aria-hidden="true"
    ></idp-error-tooltip>
    <span
      *ngIf="focused && (errorState || error)"
      aria-atomic="true"
      aria-live="polite"
      class="sr-only"
      role="alert"
    >
      {{ errorMessage }}
    </span>

    <label
      (change)="notify($event)"
      (focusin)="setFocused()"
      class="idp-radio-button idp-radio-button__label"
    >
      <input
        #inputReference
        (blur)="focusOut()"
        (click)="interaction.emit($event)"
        (focus)="setInputFocus()"
        (keydown.enter)="interaction.emit($event)"
        [attr.aria-label]="labelTxt ? labelTxt : ariaLabel"
        [checked]="checked"
        [disabled]="disabled"
        [id]="id"
        [name]="formControlName"
        [ngClass]="errorState || error ? 'idp-radio--error' : ''"
        [value]="value"
        class="idp-radio"
        data-test-radio-button="true"
        type="radio"
      />
      <span class="idp-radio-button__inner"></span>
      <span
        class="idp-radio-button__text"
        [attr.aria-hidden]="text ? true : false"
        [innerHTML]="text"
      ></span>
    </label>
  </div>
</div>
